import React, { useCallback, useEffect, useState } from "react";
import FlusterVote from "../components/FlusterVote";
import Socket from "socket";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  staticBounceVariants
} from "shared/components/animations";
const FLUSFlusterResult = ({
  averagePoints,
  isAskerPlayer,
  roomId,
  screens
}) => {
  const [counter, setCounter] = useState(10);

  const answerer_player_btn = _.get(
    screens,
    "answerer.10_aroundthehornresult.button",

    "NEXT ROUND"
  );
  useEffect(() => {
    let timer;
    timer =
      counter > 0 && setInterval(() => setCounter((prev) => prev - 1), 1000);
    counter === 0 && onUpdateStatus("update");
    return () => clearInterval(timer);
  }, [counter]);

  const buttonPressAction = () => {
    const data = {
      action: "update-status",
      tableTopName: "Fluster",
      roomId
    };
    Socket.sendMessage(data);
  };
  const onUpdateStatus = useCallback(
    _.debounce((type) => buttonPressAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [roomId]
  );
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <FlusterVote votePoint={averagePoints} />

      {isAskerPlayer && (
        <motion.div
          variants={staticBounceVariants}
          className="result-btn"
          onClick={onUpdateStatus}
        >
          <p>
            {answerer_player_btn} <span>{counter}</span>
          </p>
        </motion.div>
      )}
    </motion.div>
  );
};

export default FLUSFlusterResult;
